"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Correctness = void 0;
var Correctness;
(function (Correctness) {
    Correctness["CORRECT"] = "Correct";
    Correctness["INCORRECT"] = "Incorrect";
})(Correctness = exports.Correctness || (exports.Correctness = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29ycmVjdG5lc3MuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY29uc3RhbnRzL0NvcnJlY3RuZXNzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLElBQVksV0FHWDtBQUhELFdBQVksV0FBVztJQUNyQixrQ0FBbUIsQ0FBQTtJQUNuQixzQ0FBdUIsQ0FBQTtBQUN6QixDQUFDLEVBSFcsV0FBVyxHQUFYLG1CQUFXLEtBQVgsbUJBQVcsUUFHdEIifQ==